import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { ClarificationRequestHistoryDescriptor } from './model/clarification.request.history';

@Injectable()
export class ClarificationRequestHistoryService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'ClarificationRequestHistoryManagement',
      authService,
      config.CMSConfig
    );
  }

  public getClarificationRequests(view?: View): Promise<List<ClarificationRequestHistoryDescriptor>> {
    return super.get<List<ClarificationRequestHistoryDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public getById(id: string): Promise<ClarificationRequestHistoryDescriptor> {
    return super.get<ClarificationRequestHistoryDescriptor>(id);
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/clarification.request.history/clarification.request.history.service.ts